import React from 'react';
import { render } from 'react-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {
  createGenerateClassName,
  StylesProvider,
} from '@material-ui/core/styles';
import { muiThemeNext } from './material-ui-theme';
import 'normalize.css';
import 'resources/styles/global.scss';
import 'resources/styles/theme.scss';
import 'resources/styles/typography.scss';
import 'resources/styles/veritone-icons-26.css';
import 'resources/styles/engine-icons.css';

import 'react-infinite-calendar/styles.css';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

// polyfills:
require('core-js/fn/promise');

// sentry:
if (!__DEV__) {
  const Raven = require('raven-js');

  if (window.config.sentryDSN) {
    Raven.config(window.config.sentryDSN, {
      environment: window.config.nodeEnv,
    }).install();
  }
}

import { boot } from 'modules/boot';
import { fetchUser, setReferrer } from 'modules/user';

// The flow here looks circuitous but we have to hack around a few
// webpack/hot-loader foibles to get the combo we want of code splitting,
// tree shaking and hot reloading working together.
import { RootComponent, runConfig } from './configure';
const { store, history, rootRoute } = runConfig();

/**
 * load aiwarejs
 */
document.getElementsByTagName('head')[0].insertAdjacentHTML(
  'beforeend',
  // eslint-disable-next-line max-len
  `<link rel="stylesheet" type="text/css" href="${window.config.aiwareJSPath}${window.config.aiwareJSVersion}/js-core.umd.min.css">`
);

const aiwareJSScript = document.createElement('script');
aiwareJSScript.setAttribute(
  'src',
  `${window.config.aiwareJSPath}${window.config.aiwareJSVersion}/js-core.umd.min.js`
);
document.head.appendChild(aiwareJSScript);
/**
 * end load aiwarejs
 */

const generateClassName = createGenerateClassName({
  // By enabling this option, if you have non-MUI elements (e.g. `<div />`)
  // using MUI classes (e.g. `.MuiButton`) they will lose styles.
  // Make sure to convert them to use `styled()` or `<Box />` first.
  disableGlobal: true,
  // Class names will receive this seed to avoid name collisions.
  seed: 'mui-jss',
});

const AppMarkup = () => {
  let markup = (
    <StylesProvider generateClassName={generateClassName}>
      <MuiThemeProvider theme={muiThemeNext}>
        <RootComponent store={store} history={history} rootRoute={rootRoute} />
      </MuiThemeProvider>
    </StylesProvider>
  );

  if (__DEV__) {
    const { AppContainer } = require('react-hot-loader');
    const RedBox = require('redbox-react').default;

    markup = <AppContainer errorReporter={RedBox}>{markup}</AppContainer>;
  }

  return markup;
};

// kick off app by loading initial resources
Promise.resolve(store.dispatch(boot()))
  .then(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = urlParams.get('source');

    if (referrer) {
      sessionStorage.setItem('source', referrer);
    }
    // user could have already been redirected from machinebox prior
    const source = sessionStorage.getItem('source');

    if (source) {
      return store.dispatch(setReferrer(source));
    }

    return null;
  })
  .then(() => store.dispatch(fetchUser()))
  .then(() => {
    // Render the React application to the DOM
    render(AppMarkup(), document.getElementById('app'));

    // hide initial loading screen (compiled into index.ejs)
    return (document.getElementById('loader').innerHTML = '');
  });

// hook up hot reload for live updates in dev
if (__DEV__ && module.hot) {
  module.hot.accept('./configure', () => {
    render(AppMarkup(), document.getElementById('app'));
  });
}



// WEBPACK FOOTER //
// ./src/client/index.js